import $ from 'jquery';

// Show the intro label if input is empty
$(window).on('load', function(){
	if( $('.js-intro-label').siblings('input').length > 0 ){
		if( $('.js-intro-label').siblings('input').val().length === 0 ) {
			$('.js-intro-label').removeClass('hidden');
		}
	}
} );

// Remove the intro label if input is in focus
if( $('.js-intro-label').length > 0 ){
	$('.js-intro-label').siblings('input').on('click', function(e) {
		var $this = $(this);
		$this.siblings('.js-intro-label').addClass('hidden');
	} );
}